import { useMutation, useQueryClient } from '@tanstack/react-query';
import { PartnerService } from '../PartnerService';

export const useCreatePartner = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data) => PartnerService.createPartner(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['partners'] });
    },
  });
};

export const useAddPartnerMember = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ orgId, data }) =>
      PartnerService.addPartnerMember({ orgId, data }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['partner-members'] });
    },
  });
};
